<template>
  <li class="nav-item whitespace-nowrap" role="presentation">
    <a :href="'#tabs-' + idTab" class="
      nav-link
      block
      font-medium
      text-xs
      leading-tight
      border-x-0 border-t-0 border-b-2 border-blue-200
      px-6
      py-3
      my-2
      hover:border-blue-200 hover:bg-gray-100
      focus:border-blue-200
    " :class="[{active: selected}, classes]" :id="'tabs-' + idTab + '-tab'" data-bs-toggle="pill" :data-bs-target="'#tabs-' + idTab" role="tab" :aria-controls="'tabs-' + idTab"
      :aria-selected="selected">{{ title }}</a>
  </li>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    idTab: {
      type: String,
      default() {
        return `${uuid()}`
      },
    },
    title: {
      type: String,
      default() {
        return `TAB`
      },
    },
    selected: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
  },
  components: {
    
  },
  methods: {
    
  },
}
</script>
<style>
  
</style>